import { useEffect } from 'react';

const beaconId = 'f946891a-cc6a-4773-91f1-ac41d07d0a6d';
const beaconScriptUrl = 'https://beacon-v2.helpscout.net';
const identityUrl = '/api/helpscout/beacon';

type BeaconCall = { method: string; options?: unknown; data?: unknown };
type Beacon = { (method: string, options?: unknown, data?: unknown): void; readyQueue: BeaconCall[] };

declare global {
  interface Window {
    Beacon?: Beacon;
  }
}

function getBeacon(): Beacon {
  let beacon = window.Beacon;
  if (!beacon) {
    const queued = ((method: string, options?: unknown, data?: unknown) => {
      queued.readyQueue.push({ method: method, options: options, data: data });
    }) as Beacon;
    queued.readyQueue = [];
    window.Beacon = queued;
    const script = document.createElement('script');
    script.async = true;
    script.src = beaconScriptUrl;
    document.head.appendChild(script);
    queued('init', beaconId);
    beacon = queued;
  }
  return beacon;
}

async function identifyViewer(beacon: Beacon): Promise<void> {
  try {
    const response = await fetch(identityUrl, { credentials: 'same-origin' });
    if (response.ok) {
      const identity = await response.json();
      beacon('identify', identity);
    }
  } catch {} // The beacon still opens anonymously; identity is best-effort
}

export function openAiAnswers(): void {
  const beacon = getBeacon();
  beacon('navigate', '/ai-answers/');
  beacon('open');
}

export function HelpBeacon() {
  useEffect(() => {
    void identifyViewer(getBeacon());
  }, []);
  return null;
}
